import { useEffect } from "react";
import { FunctionFactory } from "survey-core";

const useRegexMatch = () => {
  useEffect(() => {
    const registerFunction = () => {
      try {
        if (FunctionFactory && FunctionFactory.Instance) {
          FunctionFactory.Instance.register("regexMatch", function (value) {
            if (!value) return false;
            const [data, pattern] = value;
            const regex = new RegExp(pattern);
            return regex.test(data);
          });
        } else {
          console.error(
            "FunctionFactory or FunctionFactory.Instance is not available."
          );
        }
      } catch (error) {
        console.error("Error registering custom function 'regexMatch':", error);
      }
    };

    // Delay registration to ensure FunctionFactory is available
    const registrationTimeout = setTimeout(registerFunction, 1000);

    return () => {
      clearTimeout(registrationTimeout);
      try {
        if (FunctionFactory && FunctionFactory.Instance) {
          FunctionFactory.Instance.unregister("regexMatch");
        } else {
          console.error(
            "FunctionFactory or FunctionFactory.Instance is not available for unregistration."
          );
        }
      } catch (error) {
        console.error(
          "Error unregistering custom function 'regexMatch':",
          error
        );
      }
    };
  }, []);
};

export default useRegexMatch;
